import { LayoutType } from 'src/app/core';
import { LayoutConfigBuilder } from 'src/app/layouts/default-layout/builders/layout-config.builder';
import { LayoutConfigPresets } from 'src/app/layouts/default-layout/models/layout-structures.models';

export enum SkillsRoutesConfig {
	BASE_URL = 'skills',
	LIST_SEGMENT = 'list',
	JOB_TITLES_SEGMENT = 'job-titles',
	NEW_SEGMENT = 'new',
	EDIT_SEGMENT = 'edit',
	GUID_SEGMENT = ':guid',
	JOB_TITLE_NAME_SEGMENT = ':job-title',
	COURSES_SEGMENT = 'courses',
	LEARNERS_SEGMENT = 'learners'
}

export const SkillsRouteTitles = {
	skills: 'lup.skills.title',
	jobTitles: 'lup.skills.job_titles'
};

export const skillsLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.default)
	.setBodyCssClasses(['bg--gray-lighter'])
	.setContentCssClasses(['wrap--no-subheader'])
	.showDefaultSubHeader(false)
	.build();

export const skillsSettingsLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.minimal)
	.setBodyCssClasses(['bg--gray-lighter'])
	.setContentCssClasses(['wrap--no-subheader', 'wrap--action-footer'])
	.setHeaderCssClasses(['header--no-scroll'])
	.setFooterCssClasses(['footer-white'])
	.setAdminWrapCssClasses(['admin-wrap--no-sidenav'])
	.build();

const defaultSkillsData = {
	layout: LayoutType.LARGE,
	layoutConfig: skillsLayoutConfig
};

export const dataForSkillsHomePage = {
	...defaultSkillsData
};

export const dataForSkillsList = {
	...defaultSkillsData,
	breadcrumb: 'lup.skills.list'
};

export const dataForJobTitleSkillsList = {
	...defaultSkillsData,
	breadcrumb: 'lup.skills.skills_list_breadcrumb'
};

export const dataForJobTitlesList = {
	...defaultSkillsData,
	breadcrumb: 'lup.skills.job_titles'
};

export const dataForSkillDetailsPage = {
	...defaultSkillsData,
	breadcrumb: 'skill-details' //Placeholder for breadcrumb since we are setting dynamic breadcrumb in SkillDetailsComponent. This way we are preserving breadcrumb ordering and after Skill is fetched we replacing placeholder with Skill name
};

export const dataForJobTitleDetailsPage = {
	...defaultSkillsData,
	breadcrumb: 'job-title-details' //Placeholder for breadcrumb since we are setting dynamic breadcrumb in JbTitleDetailsComponent. This way we are preserving breadcrumb ordering and after Job title is fetched we replacing placeholder with Job title name
};

export const dataForCoursesList = {
	...defaultSkillsData,
	breadcrumb: 'lup.skills.courses'
};

export const dataForLearnersList = {
	...defaultSkillsData,
	breadcrumb: 'lup.skills.learners'
};

export const dataForNewAndUpdateSkill = {
	layout: LayoutType.DEFAULT,
	layoutConfig: skillsSettingsLayoutConfig
};
